import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Work from "@/models/Work";


export default /*#__PURE__*/_defineComponent({
  __name: 'CWorkPreview',
  props: {
  work: {
    type: Work,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "work-preview",
    style: _normalizeStyle(`background-color: ${__props.work.color};`)
  }, [
    _createElementVNode("div", {
      class: "work-preview__logo",
      style: _normalizeStyle(`background-image: url(${__props.work.img});`)
    }, null, 4)
  ], 4))
}
}

})